export const wrapperStyles = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  padding: '24px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '6px',
  boxShadow: ({ palette }) => palette.shadow.m,
  animation: 'appear 1s ease',

  '@keyframes appear': {
    from: {
      opacity: 0,
    },

    to: {
      opacity: 1,
    },
  },
};

export const getExpandButtonStyles = isExpanded => ({
  position: 'absolute',
  [isExpanded ? 'top' : 'bottom']: '-5px',
  [isExpanded ? 'left' : 'right']: '-5px',

  '&:hover': {
    backgroundColor: 'transparent',
  },

  '& span': {
    fontWeight: 200,
    transform: 'rotate(-45deg)',
    color: ({ palette }) => palette.text.secondary,
  },
});
